import { isNil } from 'lodash';

// null -> "", 1 -> "1"
export const toStringOrEmpty = (value: unknown): string => {
  if (isNil(value)) return '';

  return String(value);
};
